<template>
  <div class="lxn-w100 lxn-h100">
    <div style="height: 2px;"></div>
    <div class="DoubleSwitchWidget-wrapper-text lxn-w100 lxn-text-center lxn-small-text" :style="currentSwitchStateColor" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{currentSwitchStateText}}
    </div>
    <div class="DoubleSwitchWidget-wrapper-switch lxn-margin-auto">
      <SingleSwitchSlim @switchClicked="toggleOutput()" :state="currentSwitchState" :bgColorOn="widgetColor" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isHubOffline" />
    </div>
    <div style="height: 2px;"></div>
    <div class="DoubleSwitchWidget-wrapper-switch lxn-margin-auto">
      <SingleSwitchSlim @switchClicked="toggleOutput2()" :state="currentSwitchState2" :bgColorOn="widgetColor" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isHubOffline2" />
    </div>
    <div class="DoubleSwitchWidget-wrapper-text lxn-w100 lxn-text-center lxn-text lxn-small-text" :style="currentSwitchStateColor2" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{currentSwitchStateText2}}
    </div>
  </div>
</template>

<script>

import SingleSwitchSlim from '@/components/SingleSwitchSlim.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'DoubleSwitchWidget',
  props: {
    index: Number
  },
  components: {
    SingleSwitchSlim,
  },
  data: function () {
    return {
      switchLocked: false,
      switchStatus: 0,
    }
  },
  computed: {
    widget: function () {
      if(this.index != -1){
        return this.$store.state.widgets[this.index];
      }else{
        return null;
      }
    },
    widgetColor: function () {
      if(this.index != -1){
        return this.$store.state.themeMainColors[this.widget.color];
      }else{
        return this.$store.state.themeMainColors[1];
      }
    },
    node: function () {
      if(this.index != -1){
        return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
      }else{
        return null;
      }
    },
    node2: function () {
      if(this.index != -1){
        return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[1]);
      }else{
        return null;
      }
    },
    hub: function () {
      if(this.index != -1){
        return this.$store.getters.getHubByUUID(this.widget.hubUUIDs[0]);
      }else{
        return null;
      }
    },
    hub2: function () {
      if(this.index != -1){
        return this.$store.getters.getHubByUUID(this.widget.hubUUIDs[1]);
      }else{
        return null;
      }
    },
    output: function () {
      if(this.index != -1){
        return this.node.outputs[this.widget.settings.outputIndices[0]];
      }else{
        return null;
      }
    },
    output2: function () {
      if(this.index != -1){
        return this.node2.outputs[this.widget.settings.outputIndices[1]];
      }else{
        return null;
      }
    },
    switchState: function () {
      if(this.index != -1){
        var switchState = this.$store.getters.getParameterValue(this.node.index, this.output.parameterId);
        if(switchState == undefined){
          return 0;
        }else{
          return switchState;
        }
      }else{
        return 1;
      }
    },
    switchState2: function () {
      if(this.index != -1){
        var switchState2 = this.$store.getters.getParameterValue(this.node2.index, this.output2.parameterId);
        if(switchState2 == undefined){
          return 0;
        }else{
          return switchState2;
        }
      }else{
        return 0;
      }
    },
    currentSwitchState: function () {
      return (this.switchState == 1) ? 'on' : 'off';
    },
    currentSwitchState2: function () {
      return (this.switchState2 == 1) ? 'on' : 'off';
    },
    isNodeOffline: function () {
      if(this.index != -1){
        if(this.node.connectionStatus == 1){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    isNodeOffline2: function () {
      if(this.index != -1){
        if(this.node2.connectionStatus == 1){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    isHubOffline: function () {
      if(this.index != -1){
        if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    isHubOffline2: function () {
      if(this.index != -1){
        if(this.hub2.connectionStatus.local == 2 || this.hub2.connectionStatus.online == 2){
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    },
    currentSwitchStateText: function () {
      if(this.isNodeOffline){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Unknown;
      }else{
        if(this.currentSwitchState == 'on'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
        }else if(this.currentSwitchState == 'off'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
        }else{
          return 'undefined'
        }
      }
    },
    currentSwitchStateText2: function () {
      if(this.isNodeOffline2){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Unknown;
      }else{
        if(this.currentSwitchState2 == 'on'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
        }else if(this.currentSwitchState2 == 'off'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
        }else{
          return 'undefined'
        }
      }
    },
    currentSwitchStateColor: function () {
      if(this.isNodeOffline){
        return 'color: #FF946B';
      }else{
        if(this.currentSwitchState == 'on'){
          return 'color: ' + this.widgetColor;
        }else if(this.currentSwitchState == 'off'){
          return 'color: #52626C';
        }else{
          return 'color: #ffffff';
        }
      }
    },
    currentSwitchStateColor2: function () {
      if(this.isNodeOffline2){
        return 'color: #FF946B';
      }else{
        if(this.currentSwitchState2 == 'on'){
          return 'color: ' + this.widgetColor;
        }else if(this.currentSwitchState2 == 'off'){
          return 'color: #52626C';
        }else{
          return 'color: #ffffff';
        }
      }
    },
  },
  methods: {
    toggleOutput: function () {
      if(this.index == -1){
        return;
      }
      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        this.$store.commit('setAppBusy', true);
        if(this.currentSwitchState == 'on'){
          var valueOfChange = 0;
        }else{
          valueOfChange = 1;
        }
        this.$store.commit('setParameterValue', {nodeIndex: this.node.index, parameterId: this.output.parameterId, parameterValue: valueOfChange});
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.node.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node.uuid,
                actions: [
                  {
                    parameterId: this.output.parameterId,
                    valueOfChange: valueOfChange,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                ]
              },
            ]
          }
        })
        .then( () => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
        })
        .catch( response => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        })
        .finally( () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        });
      }
    },
    toggleOutput2: function () {
      if(this.index == -1){
        return;
      }
      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub2.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        this.$store.commit('setAppBusy', true);
        if(this.currentSwitchState2 == 'on'){
          var valueOfChange = 0;
        }else{
          valueOfChange = 1;
        }
        this.$store.commit('setParameterValue', {nodeIndex: this.node2.index, parameterId: this.output2.parameterId, parameterValue: valueOfChange});
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub2.psk,
          destinationUUID: this.hub2.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        this.$store.dispatch('setNodesParameters', {
          messagingHook: messagingHook,
          hubUUID: this.hub2.uuid,
          nodeUUID: this.node2.uuid,
          bodyContent: {
            nodeActions: [
              {
                nodeUUID: this.node2.uuid,
                actions: [
                  {
                    parameterId: this.output2.parameterId,
                    valueOfChange: valueOfChange,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                    timeDelay: 0
                  }
                ]
              },
            ]
          }
        })
        .then( () => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
        })
        .catch( response => {
          this.switchLocked = false;
          this.$store.commit('setAppBusy', false);
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        })
        .finally( () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub2.index,
            stateUpdateEnabled: true,
          });
        });
      }
    },
  },
}
</script>

<style>
  .DoubleSwitchWidget-wrapper-switch {
    height: 20px;
    width: 60px;
  }
  .DoubleSwitchWidget-wrapper-text {
    height: 12px;
    line-height: 12px;
  }
</style>
